<template>
  <div class="Jobfairindex">

<!--   <div class="table1">
      <div class="tableSpan">
        <span class="spanColor">管理员列表</span>
        <span @click="handleRolemanagement">角色管理</span>
      </div>
    </div> -->
    <search-bar  ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">

        <div slot="search-cont">

          <div class="item">
            <div class="item-label">角色</div>
            <el-select  v-model="info.role_id" size="small" slot="prepend" placeholder="角色" @change="handleSeach" style="130px">
              <el-option v-for="item in options" :key="item.id" :label="item.remark" :value="item.id">
              </el-option>
            </el-select>
          </div>

            <div class="item" >
              <div class="item-label">用户名</div>
              <div style="width: 300px;" >
                <el-input placeholder="请输入用户名" v-model="info.name" class="input-with-select" size="small" @keyup.enter.native='handleSeach'>
                </el-input>
              </div>
            </div>

            <!--  操作按钮 start -->
              <div class="item">
                <el-button class="item-btn" type="primary" @click="handleSeach">查询</el-button>
                <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
              </div>
            <!--  操作按钮 end -->

        </div>

    </search-bar>

    <div class="operation-tool">
      <div @click="handleAdminindexAdd('')" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加管理员</div>
    </div>

    <div class="l-panel">
          <div class="panel-body">
            <div class="admin-list" >

             <el-row>
                <el-col v-for="(item,index) in tableData" :key="index" class="p-item" :span="6">
                  <div class="title">
                    <img class="headimg" ></img> <div class="e-name"> <div class="name">{{item.username}}</div>
                    <div class="role">{{item.rolename?item.rolename:"--"}}</div> </div>
                  </div>
                  <div class="content">
                    <div>创建时间：{{item.add_time}}</div>
                    <div>最后登录时间：{{item.last_login_time}}</div>
                    <div>最后登录ip：{{item.last_login_ip}}</div>
                    <div>状态：  <span v-if="item.status == 1">在职</span>
                                 <span v-if="item.status == 2">离职</span>
                    </div>
                    <div style="color: #1A71E2;">数据类型：{{item.departmenttype}}</div>
                    <div>绑定账号：{{item.oausername}}({{item.oamobile}})</div>
                    <div>电话：{{item.mobile}}</div>
                  </div>
                  <div class="opt-btns"> <div @click="handleAdminindexAdd(item.id)" class="p-btn upd-btn">修改</div>
                   <div class="p-btn del-btn"  @click="handledele(item.id)">删除</div> </div>
                </el-col>

              </el-row>
            </div>

      <div class="c-table-pager">
        <el-pagination @current-change="handleCurrentChange" :page-size="page_size"  :total="total">
        </el-pagination>
      </div>

      </div>
    </div>

  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  export default {
    data() {
      return {
        activeName:"first",
        page_size:8,
        info: {
          page: 1
        },
        options: [],
        total: 1,
        tableData: [],
        Selection_id: "",
        projectModel: true
      };
    },
    activated() {
      this.getData();
      this.gets("public/rolelist").then((res) => {
        this.options = res.data.data
      });
    },
    methods: {
      handleRolemanagement() {
        this.$router.push({
          path: '/rolemanagement'
        })
      },
      //删除
      handledele(id) {
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
          .then(() => {
            this.gets("admin/delete?id=" + id).then((res) => {
              if (res.data.code == 1) {
                Message.success(res.data.msg);
                this.getData();
              } else {
                Message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      },
      clearQuery() {
        for(let key in this.info) {
          this.info[key] = "";
        }
        this.info.page = 1;
        this.getData()
      },

      handleAdminindexAdd(id) {
        console.log(id);
        if (id) {
          var ids = id;
        } else {
          var ids = "";
        }
        this.$router.push({
          path: "/AdminindexAdd?id=" + ids,
        });
      },
      handleSeach() {
        this.info.page = 1;
        this.getData();
      },
      //分页
      handleCurrentChange(val) {
        this.info.page = val;
        this.getData();
      },
      getData() {
        this.info.page_size = this.page_size;
        if (this.date) {
          this.info.begintime = this.date[0];
          this.info.endtime = this.date[1];
        } else {
          this.info.begintime = "";
          this.info.endtime = "";
        }
        this.gets("admin/index", this.info).then((res) => {

          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        });
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
          let sHeight = val;
          let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
          this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
    },
  };
</script>

<style lang="scss" src="../../style/page/adminList.scss"></style>



// WEBPACK FOOTER //
// src/view/system/Adminindex.vue